import { render, staticRenderFns } from "./DigitalBusinessCardSingle.vue?vue&type=template&id=0894a9a8&"
import script from "./DigitalBusinessCardSingle.vue?vue&type=script&lang=js&"
export * from "./DigitalBusinessCardSingle.vue?vue&type=script&lang=js&"
import style0 from "./DigitalBusinessCardSingle.vue?vue&type=style&index=0&id=0894a9a8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports